import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { DeviceModelGroup, DeviceModelGroupSearchParam } from '../models';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceModelGroupService {

  private path = '/device_model_groups';

  constructor(private http: AlloxApiService) { }

  public search(param?: DeviceModelGroupSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new DeviceModelGroup(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new DeviceModelGroup(obj))
    );
  }

  public post(item: DeviceModelGroup) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: DeviceModelGroup) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: DeviceModelGroup[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
